import * as React from "react";
import { FunctionComponent } from "react";
import { ErrorStyle } from "./errorStyle";
import { Icon } from "@style/icon";
import { ApolloError } from "apollo-client";

export interface ErrorProps {
    errorMessage: string;
    originalError?: ApolloError;
}

export const Error: FunctionComponent<ErrorProps> = ({ errorMessage, originalError }) => {

    console.warn(originalError);

    return (
        <ErrorStyle>
            <Icon type="error" />
            {errorMessage}

            {originalError && originalError.message ? <pre>{originalError.message}</pre> : undefined}

        </ErrorStyle>
    );
};
